import React, { useEffect, useState, useCallback } from "react";
import { Container, Row, Col, Card, Badge } from 'react-bootstrap';
import TopBar from "./TopBar";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import {
  FaUser,
  FaHome,
  FaDonate,
  FaBuilding,
  FaClock
} from "react-icons/fa";



const ViewGurudakshina = () => {


  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const axiosPrivate = useAxiosPrivate();
  const { Id } = useParams();
  const [gurudakshinas, setGurudakshinas] = useState(null);


  const fetchGurudakshina = useCallback(async () => {
    setError(null); // clear previous error
    try {
      // const response = await axiosPrivate.get(`get-gurudakshina?id=${Id}`, {
      const response = await axiosPrivate.get(`get-gurudakshina?id=${Id}`, {
        withCredentials: true,
      });
      setGurudakshinas(response.data);
      setLoading(false);

    } catch (error) {
      console.error("Error fetching Gurudakshina:", error);
      setError(error?.response?.data?.message?.toString() || error?.message || "No Vibhags available.");
      setLoading(false);
    }
  }, [axiosPrivate, Id]); // 👈 dependency added

  useEffect(() => {
    fetchGurudakshina();
  }, [Id]);

  const formattedDate = gurudakshinas?.date_of_samarppan
    ? new Date(gurudakshinas.date_of_samarppan).toLocaleDateString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
    : "N/A";

  const formattedModifiedDate = gurudakshinas?.modified_date
    ? new Date(gurudakshinas.modified_date).toLocaleDateString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
    : "N/A";


  return (
    <>
      <section className="empbody py-4">
        <Container>
          <Card>
            <Card.Header className=" text-white gurucard">
              <h4 className="mb-0"><center>Gurudakshina Details</center></h4>
            </Card.Header>
          </Card>
          <Card className="border-success shadow-sm text-center mb-4">
            <Card.Body>
              <div className="text-muted">Gurudakshina Amount</div>
              <h4 className="text-success fw-bold">
                ₹ {gurudakshinas?.amount ?? "0"}
              </h4>
            </Card.Body>
          </Card>

          <Card className="shadow-sm mb-4">
            <Card.Header
              className="text-white"
              style={{ backgroundColor: "#13357b" }}
            >
              <FaUser size={20} color="#ffffff" />
              Personal Information
            </Card.Header>

            <Card.Body>

              <Row className="g-4">

                <Col md={4}>
                  <strong>Name</strong>
                  <div>{gurudakshinas?.name || "N/A"}</div>
                </Col>

                <Col md={4}>
                  <strong>Ultsavam</strong>
                  <div>{gurudakshinas?.sakha || "N/A"}</div>
                </Col>

                <Col md={4}>
                  <strong>Age / Shreni</strong>
                  <div>
                    {gurudakshinas?.age || "N/A"} ({gurudakshinas?.shreni || "N/A"})
                  </div>
                </Col>

                <Col md={4}>
                  <strong>Mobile</strong>
                  <div>{gurudakshinas?.mobile || "N/A"}</div>
                </Col>

                <Col md={4}>
                  <strong>Vidyarthi</strong>
                  <div>
                    <Badge bg={gurudakshinas?.vidyarthi ? "success" : "danger"}>
                      {gurudakshinas?.vidyarthi ? "Yes" : "No"}
                    </Badge>

                  </div>
                </Col>

                <Col md={4}>
                  <strong>Prathyajith</strong>
                  <div>
                    <Badge bg={gurudakshinas?.oauth_taken ? "success" : "danger"}>
                      {gurudakshinas?.oauth_taken ? "Yes" : "No"}
                    </Badge>

                  </div>
                </Col>

              </Row>

            </Card.Body>
          </Card>

          <Card className="shadow-sm mb-4">
            <Card.Header
              className="text-white"
              style={{ backgroundColor: "#13357b" }}
            >
              <FaHome size={20} color="#ffffff" />
              Address
            </Card.Header>

            <Card.Body>

              {gurudakshinas?.house_name},
              {" "}
              {gurudakshinas?.post_office}
              -
              {gurudakshinas?.pincode}

            </Card.Body>

          </Card>


          <Card className="shadow-sm mb-4">

            <Card.Header
              className="text-white"
              style={{ backgroundColor: "#13357b" }}
            >
              <FaDonate size={20} color="#ffffff" />
              Donation Details
            </Card.Header>

            <Card.Body>

              <Row className="g-4">

                <Col md={4}>
                  <strong>Payment Mode</strong>
                  <div>{gurudakshinas?.payment_mode}</div>
                </Col>

                {gurudakshinas?.payment_mode?.toUpperCase() !== "CASH" && (
                  <>
                    <Col md={4}>
                      <strong>Bank</strong>
                      <div>{gurudakshinas?.bank || "N/A"}</div>
                    </Col>

                    <Col md={4}>
                      <strong>Cheque No</strong>
                      <div>{gurudakshinas?.cheque_no || "N/A"}</div>
                    </Col>
                  </>
                )}


                {Number(gurudakshinas?.amount) > 1999 && (
                  <Col md={4}>
                    <strong>PAN</strong>
                    <div>{gurudakshinas?.pan || "N/A"}</div>
                  </Col>
                )}

                <Col md={4}>
                  <strong>Date of Samarppan</strong>
                  <div>{formattedDate}</div>
                </Col>

              </Row>

            </Card.Body>

          </Card>
          <Card className="shadow-sm mb-4">

            <Card.Header
              className="text-white"
              style={{ backgroundColor: "#13357b" }}
            >
              <FaBuilding size={20} color="#ffffff" />
              Organization
            </Card.Header>

            <Card.Body>

              <Row>

                <Col md={4}>
                  <strong>Sthan</strong>
                  <div>{gurudakshinas?.sthan_name}</div>
                </Col>

                <Col md={4}>
                  <strong>Mandal</strong>
                  <div>{gurudakshinas?.mandal_name}</div>
                </Col>

                <Col md={4}>
                  <strong>Khand</strong>
                  <div>{gurudakshinas?.khand_name}</div>
                </Col>

              </Row>

            </Card.Body>

          </Card>

          <Card className="shadow-sm">

            <Card.Header
              className="text-white"
              style={{ backgroundColor: "#13357b" }}
            >

              <FaClock size={20} color="#ffffff" />
              Audit Information
            </Card.Header>

            <Card.Body>

              <strong>Modified Date</strong>

              <div>{formattedModifiedDate}</div>

            </Card.Body>

          </Card>


        </Container>
      </section>
      <TopBar />
    </>
  );
};

export default ViewGurudakshina;
